import { z } from 'zod'

const refreshTokenSchema = z.object({
  exp: z.coerce.number(),
})

type RefreshTokenData = z.infer<typeof refreshTokenSchema>

export { refreshTokenSchema, type RefreshTokenData }
